import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, makeStyles, Tooltip } from '@material-ui/core'
import clsx from 'clsx'
import Icon from '../../../../../atoms/Icon'
import { useStatusReportContext } from '../../../statusReportContext'

const useStyles = makeStyles((theme) => ({
  actionContainer: {
    position: 'relative',
    display: 'flex',
    gap: 'var(--dim-4)',
    padding: 'var(--dim-4) 0',
    alignItems: 'stretch'
  },
  actions: {
    position: 'absolute',
    top: '21px',
    right: '5px',
    zIndex: 10,
    transition: 'transform 0.3s ease-in-out',
    '&.__sidebar-in': {
      transform: 'translateX(-420px)'
    }
  }
}))

function StatusReportActionsBoardLayout ({ children, expandAll }) {
  const { setReportExpanded, reportExpanded, selectedStatusReportItemId } = useStatusReportContext()

  const classes = useStyles()

  return (
    <div className={classes.actionContainer}>
      <div className={clsx(classes.actions, { '__sidebar-in': !!selectedStatusReportItemId })}>
        {expandAll ? (
          <Tooltip title={`${reportExpanded ? 'Collapse' : 'Expand'} All`} placement='top'>
            <IconButton onClick={() => setReportExpanded(x => !x)}>
              <Icon name={reportExpanded ? 'collapse' : 'expand'} />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
      {children}
    </div>
  )
}

StatusReportActionsBoardLayout.propTypes = {
  children: PropTypes.node,
  expandAll: PropTypes.bool
}

export default StatusReportActionsBoardLayout
